<div [ngClass]="menuNotificationsStatus ? 'adomx-dropdown col-auto show' : 'adomx-dropdown col-auto'"
  style="padding-top: 4px;" *ngIf="isLogged">
  <a (click)="showNotificationsMenu()" class="toggle"><i class="fa fa-bell"></i><span
      *ngIf="store.totalUnreadNotifications > 0" class="badge-orange"></span></a>

  <!-- Dropdown -->
  <div [ngClass]="menuNotificationsStatus ? 'adomx-dropdown-menu dropdown-menu-notifications show' :
                          'adomx-dropdown-menu dropdown-menu-notifications'">
    <div class="head">
      <h5 class="title">{{countUnreadNotifications() > 1 ? 'Hai ' + countUnreadNotifications() + ' notifiche non lette'
        :
        countUnreadNotifications() === 1 ? 'Hai 1 notifica non letta' :
        'Non sono presenti nuove notifiche'}}</h5>
    </div>
    <div *ngFor="let notification of store.dropdownNotifications" class="body custom-scroll">
      <ul>
        <li>
          <a (click)="goToSelectedNotification(notification)">
            <img class="mr-2" *ngIf="!notification.hasBeenSeen" src="assets\images\icons\new.png">
            <i *ngIf="notification.hasBeenSeen" class="zmdi zmdi-notifications-none"></i>
            <p class="notification-orange">{{notification.title}}</p>&nbsp;
            <span>{{notification.date | date}}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="footer">
      <a (click)="goToNotifications()" class="view-all">Vai alle notifiche</a>
    </div>
  </div>
</div>